import { readonly, ref } from 'vue'

const authorsState = ref([])

export default function () {
  function setAuthors(value) {
    authorsState.value = value
  }

  return {
    authors: readonly(authorsState),
    setAuthors,
  }
}
